import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";

@Injectable({providedIn: 'root'})
export class CostCenters
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(params: CostCenters.Params): Observable<CostCenters.Result[]>
	{
		return this.m_queryInvoker.doQuery("CostCenters", params);
	}
};

export namespace CostCenters
{
	export class Params
	{
		searchName: string;
	};
	export interface Result
	{
		oid?: string;
		id?: string;
		proxyName?: string;
	};
};
